<div class="d-grid grid h-100">
  <ng-lottie
    [options]="lottieOptions"
    class="w-75"
  ></ng-lottie>
</div>
